import { Pedido } from '@/models/sit-pedido/pedido'
import { PaginationTableSitPedidos } from './states/table'
import { DocumentoSitPedidos } from './states/form'
import dayjs from "dayjs"
import { apiUpload } from '@/services/sit-pedidos/upload.service'
import { DocumentoAnexo } from '../renovacao-crlv'
import { VUE_APP_NAME } from '@/commons/config'

const AUTH = `${VUE_APP_NAME}-transportadora-auth`;
//import pedidoService from '@/services/sit-pedidos/pedido.service'

const currentToken = () => {
  const { token = null } = JSON.parse(localStorage.getItem(AUTH)) || {};
  return token;
};

export default {
  // Actions for Form State
  clearForm({commit}: any): void {
    commit('CLEAR_FORM')
  },

  setFormDocuments({commit}, value: DocumentoSitPedidos[]): void {
    commit('SET_FORM_DOCUMENTS', value)
  },

  setFormDocument({state, commit}: any, value: any): void {
    const { tipoDocumento, doc } = value
    const documents = state.form.documents.map((d: DocumentoSitPedidos) => {
      return d.tipoDocumento === tipoDocumento ? { ...d, ...doc} : {...d }
    })
    commit('SET_FORM_DOCUMENTS', documents)
  },

  setFormIsLoading({commit}: any, value: boolean): void {
    commit('SET_FORM_IS_LOADING', value)
  },

  setFormPedido({commit}: any, value: Pedido): void {
    commit('SET_FORM_PEDIDO', value)
  },

  setFormStep({commit}: any, value: number): void {
    commit('SET_FORM_STEP', value)
  },

  setFormPedidoContact({commit}: any, value: any): void {
    commit('SET_FORM_PEDIDO_CONTACT', value)
  },

  // Actions for Detail State
  setDetailData({commit}: any, value: Pedido): void {
    commit('SET_DETAIL_DATA', value)
  },

  setDetailIsLoading({commit}: any, value: boolean): void {
    commit('SET_DETAIL_LOADING', value)
  },

  clearDetailData({commit}: any): void {
    commit('CLEAR_DETAIL')
  },

  // Actions for Table State
  setTableContent({commit}: any, value: Pedido[]): void {
    commit('SET_TABLE_CONTENT', value)
  },

  setTableIsLoading({commit}: any, value: boolean): void {
    commit('SET_TABLE_LOADING', value)
  },

  setTableTotals({commit}: any, value: number): void {
    commit('SET_TABLE_TOTALS', value)
  },

  setTablePagination({commit}: any, value: PaginationTableSitPedidos): void {
    commit('SET_TABLE_PAGINATION', value)
  },

  clearTable({commit}: any): void {
    commit('CLEAR_TABLE')
  },

  // Actions shareds to integration in backend
  async upload({dispatch}: any, { idPedido, doc }): Promise<any> {
    let formData = new FormData()
    const dataEmissao = doc.dataEmissao ? dayjs(`${doc.dataEmissao}`, 'DD/MM/YYYY').format('YYYY-MM-DD') : ''
    const dataValidade = doc.dataValidade ? dayjs(`${doc.dataValidade}`, 'DD/MM/YYYY').format('YYYY-MM-DD') : ''
    formData.append("file", doc.file);
    formData.append("tipoDocumento", `${doc.tipoDocumento}`);
    formData.append("dataEmissao", `${dataEmissao}`);
    formData.append("dataValidade", `${dataValidade}`);
    formData.append("orgaoExpedidor", `${doc.orgaoExpedidor}`);
    formData.append("numeroComplemento", `${doc.numeroComplemento}`);

    const { token = null } = JSON.parse(localStorage.getItem(AUTH)) || {};

    return await apiUpload.post(`/api/pedidos/${idPedido}/upload-arquivo`, formData, {
      headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` },

      onUploadProgress: ({total, loaded}) => {
        const percentage = Math.round((loaded * 100) / total)
        dispatch('setFormDocument', {tipoDocumento: doc.tipoDocumento, doc: { progress: percentage }})
      }
    })
  },

  download({dispatch}: any, value: DocumentoAnexo): void {
    //dispatch('setDetailIsLoading', true)
    // const document = pedidoService.download(value).toPromise()
    // console.log(document)
    // pedidoService.download(value).subscribe((res)=>{
    //   pedidoService.doDownloadFile(res, value.nomeArquivo)
    //   dispatch('setDetailIsLoading', false)
    // }, (error)=>{
    //   dispatch('setDetailIsLoading', false)
    // })
  }
}
